





















































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import formatNumber from '@/shared/filters/format-number';

@Component
export default class ListDeposit extends Vue {
    private eventEmit = {
        eventReloadOrder: 'eventReload',
        eventCheckAll: 'eventCheckAll'
    };

    @Prop({ default: () => [] })
    private listDeposit!: any[];

    private isCheckAll = false;

    private transformNumb(value: number, format: string) {
        if (!(value > 0)) {
            return '0';
        }
        return formatNumber(value, format);
    }

    private onCheckAllOrder() {
        this.$emit(this.eventEmit.eventCheckAll, this.isCheckAll);
    }
}
